const WhitecapColors = {
    orangeLink: "#f08000",
    orange1: "#ffc20f",
    lightBlack: "#333",
    borderGray: "#d0d3d4",
    gainsboro:"#dadada",
    gray:"#e1e1e1",
    primaryYellow: "#FFCC00",
    white: "#fff",
    black: "#000",
    borderColor: "#e1e1e1",
    errorColor:"#e02b27",
    gray1: "#f6f6f6",
    gray2: "#e5e5e5",
    gray3: "#ccc",
    gray4: "#808080",
    drakGray: "#666",
    red2:"#b22009",
    blue1: "#31708f",
    blue2: "#2e64b0",
    yellow: "#eea236",
    yellow1: "#f0ad4e",
    yellow2: "#ffcc33",
    yellow3: "#d6a100",
    requiredField: "#C10000",
    lightGray: "#F7F8F9",
    hoverGray: "#E2E2E2",
    secondaryBtnBorder: "#413e40",
    filterHoverColor: "#8f8f8f",
    iconColor: "#323232",
    createAccountHeaderBtnColor: "#474747",
    badgeOrange: "#E64E25",
    badgeGreen: "#54BCAB",
};

export default WhitecapColors;
